import React from 'react';
import { AlertTriangle, CreditCard, X } from 'lucide-react';

const GracePeriodBanner = ({ daysRemaining, onDismiss, onUpdatePayment }) => {
  const urgencyColor = daysRemaining <= 3 
    ? 'bg-red-500' 
    : daysRemaining <= 7 
      ? 'bg-orange-500' 
      : 'bg-yellow-500';

  return (
    <div className={`${urgencyColor} text-white px-4 py-3`}>
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <AlertTriangle className="w-5 h-5 flex-shrink-0" />
          <div>
            <span className="font-semibold">Payment Failed</span>
            <span className="mx-2">•</span>
            <span>
              {daysRemaining <= 0 
                ? 'Your account will be locked today. Please update your payment method immediately.'
                : daysRemaining === 1
                  ? '1 day remaining to update your payment method before your account is locked.'
                  : `${daysRemaining} days remaining to update your payment method.`
              }
            </span>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={onUpdatePayment}
            className="flex items-center gap-2 px-4 py-1.5 bg-white text-gray-900 rounded-lg font-medium hover:bg-gray-100 transition-colors"
          >
            <CreditCard className="w-4 h-4" />
            Update Payment
          </button>
          {onDismiss && (
            <button
              onClick={onDismiss}
              className="p-1 hover:bg-white/20 rounded transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default GracePeriodBanner;
